import React from 'react'

interface AuthPageContainerProps {
  children: React.ReactNode
  className?: string
}
/* Intended to be used on auth pages where form is centered and small mid screen */
export const AuthPageContainer: React.FC<AuthPageContainerProps> = ({
  children,
  className = '',
}) => {
  return <div className={`flex h-screen justify-center w-full ${className}`}>{children}</div>
}
